var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultIconFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 234,
    viewBox: "0 0 447 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_9290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.042 128.233H292.973C292.973 128.233 301.307 105.466 314.135 105.466C326.963 105.466 330.982 121.176 330.982 121.176C330.982 121.176 339.635 112.642 346.751 112.642C353.867 112.642 360.04 123.925 360.04 123.925C360.04 123.925 370.09 117.856 377.042 128.233Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.029 106.419H69.7428C69.7428 106.419 78.5151 93.6948 85.4379 93.6948C92.3607 93.6948 94.3959 102.177 94.3959 102.177C94.3959 102.177 99.2761 98.2184 103.8 98.9241C108.323 99.6297 109.029 106.419 109.029 106.419Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.287 64.9197H287.001C287.001 64.9197 295.781 52.2031 302.696 52.2031C309.612 52.2031 311.654 60.6858 311.654 60.6858C311.654 60.6858 316.542 56.7267 321.058 57.4324C325.574 58.138 326.287 64.9197 326.287 64.9197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.537 173.048H133.251C133.251 173.048 142.031 160.331 148.946 160.331C155.862 160.331 157.904 168.814 157.904 168.814C157.904 168.814 162.784 164.855 167.308 165.56C171.832 166.266 172.537 173.048 172.537 173.048Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.379 59.9421H121.872C121.872 59.9421 132.353 36.5443 143.561 35.081C154.77 33.6177 160.14 52.4697 160.14 52.4697C160.14 52.4697 167.368 45.7846 173.05 45.7846C178.732 45.7846 183.107 54.594 183.107 54.594C183.107 54.594 194.45 48.57 198.379 59.9421Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.269 188.601H245.762C245.762 188.601 256.242 165.203 267.451 163.74C278.66 162.277 284.023 181.129 284.023 181.129C284.023 181.129 291.25 174.444 296.94 174.444C302.629 174.444 307.012 183.216 307.012 183.216C307.012 183.216 318.369 177.229 322.269 188.601Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.471 178.358C256.008 178.358 279.952 154.414 279.952 124.877C279.952 95.3409 256.008 71.3967 226.471 71.3967C196.935 71.3967 172.99 95.3409 172.99 124.877C172.99 154.414 196.935 178.358 226.471 178.358Z",
    fill: "#1B1D52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M226.471 178.358C256.008 178.358 279.952 154.414 279.952 124.877C279.952 95.3409 256.008 71.3967 226.471 71.3967C196.935 71.3967 172.99 95.3409 172.99 124.877C172.99 154.414 196.935 178.358 226.471 178.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.405 154.308H191.352V167.663H194.405V154.308Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.893 167.66H192.882V172.437H193.893V167.66Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.772 173.203V172.193H190.996V173.203H195.772Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.013 174.331V171.055H191.003V174.331H192.013Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.772 174.34V171.064H194.761V174.34H195.772Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.193 168.606H189.235C188.792 168.606 188.433 168.965 188.433 169.408V175.997C188.433 176.44 188.792 176.799 189.235 176.799H190.193C190.636 176.799 190.996 176.44 190.996 175.997V169.408C190.996 168.965 190.636 168.606 190.193 168.606Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.532 168.606H196.574C196.131 168.606 195.772 168.965 195.772 169.408V175.997C195.772 176.44 196.131 176.799 196.574 176.799H197.532C197.975 176.799 198.334 176.44 198.334 175.997V169.408C198.334 168.965 197.975 168.606 197.532 168.606Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.219 154.733L193.829 166.421L194.252 166.725L202.642 155.036L202.219 154.733Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.054 154.676L193.741 155.091L199.278 159.271L199.591 158.856L194.054 154.676Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.376 152.085H174.877V156.958H178.376V152.085Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.489 174.019C181.014 174.019 184.682 170.291 184.682 165.692C184.682 161.094 181.014 157.366 176.489 157.366C171.964 157.366 168.296 161.094 168.296 165.692C168.296 170.291 171.964 174.019 176.489 174.019Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.099 170.113C185.351 166.861 185.351 161.589 182.099 158.337C178.848 155.085 173.576 155.086 170.324 158.337C167.072 161.589 167.072 166.861 170.324 170.113C173.576 173.365 178.848 173.365 182.099 170.113Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.705 165.343C184.33 161.202 181.479 157.338 177.338 156.713C173.196 156.088 169.332 158.939 168.707 163.08C168.082 167.222 170.933 171.086 175.075 171.711C179.216 172.336 183.08 169.485 183.705 165.343Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.786 146.404H122.288V151.276H125.786V146.404Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.848 162.186C127.052 162.186 129.649 159.546 129.649 156.288C129.649 153.031 127.052 150.391 123.848 150.391C120.644 150.391 118.047 153.031 118.047 156.288C118.047 159.546 120.644 162.186 123.848 162.186Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.388 156.615C130.138 153.446 128.178 150.268 125.008 149.517C121.839 148.766 118.661 150.726 117.91 153.896C117.159 157.065 119.119 160.244 122.289 160.995C125.458 161.746 128.637 159.785 129.388 156.615Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.647 160.621C126.613 160.621 129.018 158.216 129.018 155.25C129.018 152.284 126.613 149.88 123.647 149.88C120.681 149.88 118.277 152.284 118.277 155.25C118.277 158.216 120.681 160.621 123.647 160.621Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.925 149.449L75.3956 142.704V144.524L210.925 156.089V149.449Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.925 149.449V156.097L204.076 155.51L206.111 149.204L210.925 149.449Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.403 167.66H258.456V154.305H255.403V167.66Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.915 172.436H256.925V167.66H255.915V172.436Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.805 173.203V172.193H254.029V173.203H258.805Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.805 174.34V171.064H257.795V174.34H258.805Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.046 174.331V171.055H254.036V174.331H255.046Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.565 168.606H259.607C259.164 168.606 258.805 168.965 258.805 169.408V175.997C258.805 176.44 259.164 176.799 259.607 176.799H260.565C261.008 176.799 261.368 176.44 261.368 175.997V169.408C261.368 168.965 261.008 168.606 260.565 168.606Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.226 168.606H252.268C251.825 168.606 251.466 168.965 251.466 169.408V175.997C251.466 176.44 251.825 176.799 252.268 176.799H253.226C253.669 176.799 254.029 176.44 254.029 175.997V169.408C254.029 168.965 253.669 168.606 253.226 168.606Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.589 154.747L247.167 155.05L255.557 166.739L255.979 166.436L247.589 154.747Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.761 154.689L250.224 158.869L250.537 159.284L256.074 155.104L255.761 154.689Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.432 156.951H274.931V152.078H271.432V156.951Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.319 174.019C277.844 174.019 281.512 170.291 281.512 165.692C281.512 161.094 277.844 157.366 273.319 157.366C268.794 157.366 265.126 161.094 265.126 165.692C265.126 170.291 268.794 174.019 273.319 174.019Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48 170.113C282.732 166.861 282.732 161.589 279.48 158.337C276.228 155.085 270.956 155.086 267.705 158.337C264.453 161.589 264.453 166.861 267.705 170.113C270.956 173.365 276.228 173.365 279.48 170.113Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.94 171.69C279.062 170.943 281.797 166.997 281.051 162.875C280.304 158.754 276.357 156.018 272.236 156.765C268.115 157.512 265.379 161.458 266.126 165.58C266.873 169.701 270.819 172.437 274.94 171.69Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.014 151.276H327.513V146.403H324.014V151.276Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.96 162.186C329.164 162.186 331.762 159.546 331.762 156.288C331.762 153.031 329.164 150.391 325.96 150.391C322.757 150.391 320.159 153.031 320.159 156.288C320.159 159.546 322.757 162.186 325.96 162.186Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.525 160.984C330.694 160.233 332.655 157.055 331.904 153.886C331.153 150.716 327.975 148.756 324.805 149.507C321.636 150.258 319.675 153.436 320.426 156.605C321.177 159.775 324.355 161.735 327.525 160.984Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.161 160.621C329.127 160.621 331.531 158.216 331.531 155.25C331.531 152.284 329.127 149.88 326.161 149.88C323.195 149.88 320.79 152.284 320.79 155.25C320.79 158.216 323.195 160.621 326.161 160.621Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.883 149.449L374.412 142.704V144.524L238.883 156.089V149.449Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.883 149.449V156.097L245.732 155.51L243.696 149.204L238.883 149.449Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.101 137.875L176.214 135.587V136.731L213.101 141.997V137.875Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.101 137.877V141.999L207.419 141.182L207.991 137.557L213.101 137.877Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.707 137.875L273.594 135.587V136.731L236.707 141.997V137.875Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.699 137.877V141.999L242.389 141.182L241.817 137.557L236.699 137.877Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.082 145.899H213.264C210.68 145.899 208.585 147.994 208.585 150.578V158.979C208.585 161.564 210.68 163.659 213.264 163.659H217.082C219.667 163.659 221.762 161.564 221.762 158.979V150.578C221.762 147.994 219.667 145.899 217.082 145.899Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.543 145.899H232.726C230.141 145.899 228.046 147.994 228.046 150.578V158.979C228.046 161.564 230.141 163.659 232.726 163.659H236.543C239.128 163.659 241.223 161.564 241.223 158.979V150.578C241.223 147.994 239.128 145.899 236.543 145.899Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.922 161.541H223.894V170.395H225.922V161.541Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.238 170.402H224.57V173.567H225.238V170.402Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.486 174.071V173.403H223.322V174.071H226.486Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.99 174.823V172.654H223.322V174.823H223.99Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.486 174.823V172.654H225.818V174.823H226.486Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.787 171.026H222.156C221.86 171.026 221.621 171.266 221.621 171.561V175.921C221.621 176.216 221.86 176.456 222.156 176.456H222.787C223.082 176.456 223.322 176.216 223.322 175.921V171.561C223.322 171.266 223.082 171.026 222.787 171.026Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.652 171.026H227.021C226.725 171.026 226.486 171.266 226.486 171.561V175.921C226.486 176.216 226.725 176.456 227.021 176.456H227.652C227.948 176.456 228.187 176.216 228.187 175.921V171.561C228.187 171.266 227.948 171.026 227.652 171.026Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.684 123.562H224.124L224.622 83.3103H225.179L225.684 123.562Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.904 162.046C214.973 162.046 208.102 155.977 208.904 142.733C209.647 130.106 217.536 123.421 224.904 123.421C232.273 123.421 240.139 130.165 240.904 142.733C241.706 155.977 234.828 162.046 224.904 162.046Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.457 135.751L217.855 133.53L217.617 137.585L212.128 138.908L213.457 135.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.651 133.448V137.571L218.085 137.556L218.33 133.448H224.651Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.351 135.751L231.953 133.53L232.191 137.585L237.68 138.908L236.351 135.751Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.156 133.448V137.571L231.723 137.556L231.478 133.448H225.156Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.47 153.266C236.997 159.208 231.663 162.046 224.904 162.046C218.145 162.046 212.811 159.238 210.338 153.266C215.114 150.34 219.578 149.485 224.904 149.485C230.23 149.485 234.694 150.34 239.47 153.266Z",
    fill: "#1B1D52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_9290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 447,
    height: 234,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultIconFlight);
export default __webpack_public_path__ + "static/media/no_result_icon_flight.2fb20bfa98e163d9a4f9ba11097b7106.svg";
export { ForwardRef as ReactComponent };